import { Link } from 'react-router';

/**
 * The wall an anonymous visitor hits after their free event-detail views. Framed
 * as a benefit ("read full details, register, save"), never "pay to continue".
 * `next` is the path to return to after they sign in.
 */
export function GateWall({ next }: { next: string }) {
  const href = `/join?next=${encodeURIComponent(next)}`;
  return (
    <section className="gate-wall" aria-label="Create a free account to continue">
      <div className="gate-wall-inner stack">
        <span className="gate-wall-eyebrow">You've been exploring</span>
        <h2 className="gate-wall-title">See the full details — free</h2>
        <p className="gate-wall-copy">
          Create a free account to read full event details, register, save events, and get reminders
          so you never miss the Bay's networking. One email, no password.
        </p>
        <Link to={href} className="ui-btn btn-primary btn-lg">
          Create a free account →
        </Link>
        <p className="tiny muted">
          Already a member? <Link to={href}>Sign in</Link> — it's the same one-tap link.
        </p>
      </div>
    </section>
  );
}

/**
 * Inline prompt for a member-only action (Save, Remind me) when the visitor is
 * signed out. Small, sits next to the action it gates.
 */
export function GatePrompt({ next, children }: { next: string; children: React.ReactNode }) {
  return (
    <Link to={`/join?next=${encodeURIComponent(next)}`} className="gate-prompt">
      {children}
    </Link>
  );
}
